export default "__VITE_ASSET__973fba6d__"